import { MarkSpec, NodeSpec } from 'prosemirror-model';
import { Extension } from './extensions/base/Extension';
import { Blockquote } from './extensions/Blockquote';
import { Code } from './extensions/Code';
import { CodeBlock } from './extensions/CodeBlock';
import { Doc } from './extensions/Doc';
import { HardBreak } from './extensions/HardBreak';
import { Heading } from './extensions/Heading';
import { HorizontalRule } from './extensions/HorizontalRule';
import { Image } from './extensions/Image';
import { Italic } from './extensions/Italic';
import { Link } from './extensions/Link';
import { ListItem } from './extensions/ListItem';
import { Mention } from './extensions/Mention';
import { OrderedList } from './extensions/OrderedList';
import { Paragraph } from './extensions/Paragraph';
import { Strikethrough } from './extensions/Strikethrough';
import { Strong } from './extensions/Strong';
import { Text } from './extensions/Text';
import { Underline } from './extensions/Underline';
import { UnorderedList } from './extensions/UnorderedList';

export type Nodes =
  | 'doc'
  | 'text'
  | 'paragraph'
  | 'heading'
  | 'horizontal_rule'
  | 'hard_break'
  | 'image'
  | 'code_block'
  | 'list_item'
  | 'bullet_list'
  | 'ordered_list'
  | 'mention'
  | 'blockquote';
export type Marks =
  | 'code'
  | 'em'
  | 'strong'
  | 'underline'
  | 'strikethrough'
  | 'link'
  | 'suggestion_insertion'
  | 'suggestion_deletion';
export type Extensions =
  | 'mention-menu-trigger'
  | 'emoji-menu-trigger'
  | 'placeholder'
  | 'paste-handler';

export const ALL_NODES = [
  new Doc(),
  new Text(),
  new Mention(),
  new Paragraph(),
  new Heading(),
  new HorizontalRule(),
  new Image(),
  new CodeBlock(),
  new ListItem(),
  new UnorderedList(),
  new OrderedList(),
  new Blockquote(),
  new HardBreak(),
] as Array<Extension<NodeSpec>>;

export const ALL_MARKS = [
  new Code(),
  new Italic(),
  new Strong(),
  new Underline(),
  new Strikethrough(),
  new Link(),
] as Array<Extension<MarkSpec>>;
